module.exports = __webpack_public_path__ + "static/media/cover.484497f0.png";